var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 58",
    x: 32,
    y: 29,
    width: 32,
    height: 29,
    transform: "rotate(-180 32 29)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M26 2.99974L6 14.5467L26 26.0938",
    stroke: "#727E8C",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.532f39990fdd9cd9a0ad4b3def41abd4.svg";
export { ForwardRef as ReactComponent };